import { Navigate, Route, Routes } from "react-router-dom";
import { AuthenticatedAppShell } from "@/components/auth/AuthGate";
import { ClientHome } from "@/components/ClientHome";
import { ConfigurationScreen } from "@/components/configuration/ConfigurationV2";
import { RequestsDashboard } from "@/components/RequestsDashboard";
import { LoginCallbackPage } from "@/pages/LoginCallbackPage";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<ClientHome />} />
      <Route path="/callback" element={<LoginCallbackPage />} />
      <Route
        path="/dashboard"
        element={
          <AuthenticatedAppShell>
            <RequestsDashboard />
          </AuthenticatedAppShell>
        }
      />
      <Route
        path="/configuration"
        element={
          <AuthenticatedAppShell>
            <ConfigurationScreen />
          </AuthenticatedAppShell>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
